export default __webpack_public_path__ + "static/media/feature_5@2x.b6b81a5d.png";